module.exports = __webpack_public_path__ + "static/media/jobbeurs_home_mobile.4219fe89.jpg";